<app-navbar></app-navbar>
<div class="listar-productos-container">
  <h1>Lista de Productos de la Estadía</h1>
  <table *ngIf="productos.length > 0; else noProductos">
    <thead>
      <tr>
        <th>Nombre</th>
        <th>Valor Neto</th>
        <th>Descripción Corta</th>
        <th>Acciones</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let producto of productos">
        <td>{{ producto.nombre }}</td>
        <td>{{ producto.valor_neto | currency:'USD' }}</td>
        <td>{{ producto.descripcion_corta }}</td>
        <td>
          <button (click)="editarProducto(producto)">Actualizar</button>
        </td>
      </tr>
    </tbody>
  </table>
  <ng-template #noProductos>
    <p>No hay productos disponibles para esta estadía.</p>
  </ng-template>
</div>
<app-footer></app-footer>